import React, {useEffect, useState} from 'react';
import {
    useTheme,
    Box,
    Stack,
    Typography,
    TextField,
    Divider,
    Switch,
    Button,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    RadioGroup,
    Radio,
    FormControlLabel,
    FormControl,
    InputLabel,
    IconButton,
    Checkbox,
    Select,
    MenuItem
    // Fade,
    // IconButton,
    // Menu,
    // MenuItem,
} from "@mui/material";
import LinearProgress from '@mui/material/LinearProgress';
import EditIcon from '@mui/icons-material/Edit';
// import FormControl from '@mui/material/FormControl';
// import FormHelperText from '@mui/material/FormHelperText';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';

// import MenuIcon from '@mui/icons-material/Menu';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import SearchIcon from '@mui/icons-material/Search';
// import DirectionsIcon from '@mui/icons-material/Directions';

import {tokens} from "../../theme";
import appealsStore from '../../store/appealsStore';
import BillingService from "../../services/BillingService";
import UserResultElement from './UserResultElement';
// import YaMap from '../YaMap/YaMap';

const AppealEdit = ({appeal=null, open, handleClose}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(true);
    
    const appealGroups = appealsStore.getAppealGroup();
    const providers = appealsStore.getProviders();
    const billings = appealsStore.getBillings()
    
    const descriptionElementRef = React.useRef(null);

    useEffect(() => {
        if (appeal) {
            setChange(false)
            setProvider(providers.find(provider => provider.id === appeal.provider_id))
            setBilling(billings.find(billing => billing.provider_id === appeal.provider_id))
            switch(appeal.source_type) {
                case 'user':
                    setAppealNameText(appeal.crm_object.login)
                    break
                default: 
                    setAppealNameText(appeal.source)
                    setMobileTelephone(appeal.source)
                    break
            }
        }
        else {
            setChange(true)
            setAppealNameText("")
        }
        
        setIsOpen(appeal ? appeal.is_open ? true : false : true)
        setGroupId(appeal ? appeal.group_id : false)
        setEditSourceFlag(false)
        setSource(appeal ? appeal.source : "")
        setSourceType(appeal ? appeal.source_type : "")
        setNewSubscriber(false)
        setLogin("")
        setFullName("")
        setSourceType(appeal ? appeal.source_type : "")
        setErrorMessage("")
        setErrorMessageText("")
        setErrorBilling("")
        setErrorLogin("")
        setErrorFullName("")
        setErrorMobileTelephone("")
        setResult([])
        setMessageText("")
    }, [appeal, billings, providers])

    const [provider, setProvider] = useState({})

    const [appealNameText, setAppealNameText] = useState("")

    const [isOpen, setIsOpen] = useState(true)
    const handleChangeIsOpen = (event) => {
        if (event.target.checked) {
            setIsOpen(true);
        }
        else {
            setIsOpen(false);
        }
    };

    const [groupId, setGroupId] = useState(false)
    const handleChangeGroup = (event) => {
        setGroupId(parseInt(event.target.value, 10))
    }

    const [source, setSource] = useState("")
    const [sourceType, setSourceType] = useState("")
    const [editSourceFlag, setEditSourceFlag] = useState(false)
    const handleEditAppealSource = () => {
        setAppealNameText(appeal.source)
        setResult([])
        setEditSourceFlag(!editSourceFlag)
    }
    const handleClickSource = (user) => {
        setAppealNameText(user.login)
        setSource(user.billing_id + ":" + user.user_id)
        setSourceType("user")
        setResult([])
        setEditSourceFlag(false)
    }

    const [messageText, setMessageText] = useState("")
    const [errorMessageText, setErrorMessageText] = useState("")
    const handleChangeMessageText = (event) => {
        setMessageText(event.target.value)
    }

    const [errorMessage, setErrorMessage] = useState("")
    const handleSave = async () => {
        setLoading(false)
        setErrorMessage("")
        if (!messageText) {
            setErrorMessageText("Enter a comment")
            setLoading(true)
            return
        }
        if (newSubscriber) {
            const user = await BillingService.users(
                billing.billing_id,
                {
                    login: login,
                    full_name: fullName,
                    mobile_telephone: mobileTelephone,
                    password: "123"
                }
            )
            if (user.status !== 200 || user.data.hasOwnProperty('error') || !user.data.hasOwnProperty('user_id')) {
                setErrorMessage("Error adding user to billing.")
                setLoading(true)
                return
            }
            await appealsStore.sendMessage(appeal.id, messageText)
            setMessageText("")
            appeal.source = billing.billing_id + ":" + user.data.user_id
            appeal.source_type = 'user'
            appeal.is_open = isOpen
            appeal.group_id = groupId
            const put_appeal = await appealsStore.putAppeal(appeal.id, appeal)
            if (put_appeal.status !== 200) {
                setErrorMessage("Error updating request.")
                setLoading(true)
                return
            }
            setLoading(true)
            handleClose()
        }
        else {
            await appealsStore.sendMessage(appeal.id, messageText)
            setMessageText("")
            appeal.is_open = isOpen
            appeal.group_id = groupId
            appeal.source = source
            appeal.source_type = sourceType
            // const source_split = source.split(':')
            // appeal.crm_object = {
            //     billing_id: source_split[0],
            //     user_id: source_split[1],
            //     login: source_split[1],
            // }
            const put_appeal = await appealsStore.putAppeal(appeal.id, appeal)
            if (put_appeal.status !== 200) {
                setErrorMessage("Error updating request.")
                setLoading(true)
                return
            }
            setLoading(true)
            handleClose()
        }
    }

    const [newSubscriber, setNewSubscriber] = useState(false)
    const handleChangeNewSoubscriber = (event) => {
        setNewSubscriber(event.target.checked)
    }

    const [billing, setBilling] = useState({})
    const [errorBilling, setErrorBilling] = useState("")
    const handleChangeBilling = (event) => {
        // const billing_id = event.target.value
        setBilling(event.target.value)
        if (event.target.value === 0) {
            setErrorBilling("Incorrect input")
        }
        else {
            setErrorBilling("")
        }
    }

    const [login, setLogin] = useState("")
    const [errorLogin, setErrorLogin] = useState("")
    const handleChangeLogin = (event) => {
        setLogin(event.target.value)
        const pattern = /^[a-z0-9_-]+$/;
        if (!pattern.test(event.target.value)) {
            setErrorLogin("Incorrect input")
        }
        else {
            setErrorLogin("")
        }
    }

    const [fullName, setFullName] = useState("")
    const [errorFullName, setErrorFullName] = useState("")
    const handleChangeFullName = (event) => {
        setFullName(event.target.value)
        if (event.target.value.length === 0) {
            setErrorFullName("Incorrect input")
        }
        else {
            setErrorFullName("")
        }
    }

    const [mobileTelephone, setMobileTelephone] = useState("")
    const [errorMobileTelephone, setErrorMobileTelephone] = useState("")
    const handleChangeMobileTelephone = (event) => {
        setMobileTelephone(event.target.value)
        const pattern = /^[0-1]+$/;
        if (!pattern.test(event.target.value)) {
            setErrorMobileTelephone("Incorrect input")
        }
        else {
            setErrorMobileTelephone("")
        }
    }

    const [result, setResult] = useState([])
    useEffect(() => {
        const fetcher = async () => {
            try {
                const billing_users = await BillingService.billing_users(0, 10, appealNameText, provider.id);
                setResult(billing_users.data.billingUsers);
            } catch (e) {
                console.log(e);
            }
        };
        if (editSourceFlag) {
            fetcher()
        }
    }, [appealNameText, editSourceFlag, provider.id])

    const [change, setChange] = useState(false)
    useEffect(() => {
        if (appeal) {
            setChange(false)
            if (isOpen !== appeal.is_open || groupId !== appeal.group_id || source !==appeal.source) {
                setChange(true)
            }
        }
        if (newSubscriber) {
            setChange(true)
        }
    }, [appeal, isOpen, groupId, source, newSubscriber] )

    return (
        <Box>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={'body'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">
                    {appeal 
                        ?   <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                                {provider ? provider.name : "undefined"} - {appealGroups.find(group => group.id === appeal.group_id).name}
                            </Typography>
                        :   <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>
                                New appeal
                            </Typography> 
                    }
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        // p={5}
                    >
                        {/* <Divider /> */}
                        {/* Loading and errors */}
                        {!loading && <LinearProgress /> }
                        {errorMessage && <Typography>{errorMessage}</Typography>}
                        {/* Source of reference */}
                        {/* {setAppeal.is_open} */}
                        <Stack spacing={3}>
                            {/* Appeal */}
                            <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 320 }}
                            >   
                                <Stack>
                                    <Typography variant='subtitle2' pb={1} pt={1} sx={{ color: colors.greenAccent[500] }}>Источник обращения / Статус обращения</Typography>
                                    <Stack direction={"row"} sx={{ display: 'flex', alignItems: 'center', width: 320 }}>
                                        {/* Menu */}
                                        {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
                                            <MenuIcon />
                                        </IconButton> */}
                                        <InputBase
                                            sx={{ ml: 1, flex: 1 }}
                                            placeholder="Source of appeal"
                                            value={appealNameText}
                                            inputProps={{ 'aria-label': 'search google maps' }}
                                            onChange={e => setAppealNameText(e.target.value)}
                                            disabled={!editSourceFlag}
                                        />
                                        {(sourceType === 'incoming_call' || sourceType === 'max' || sourceType === 'website') && !newSubscriber &&
                                            <IconButton type="button" sx={{ p: '10px' }} aria-label="edit" onClick={handleEditAppealSource}>
                                                <EditIcon />
                                            </IconButton>
                                        }   
                                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                        <Switch 
                                            checked={isOpen}
                                            onChange={handleChangeIsOpen}
                                            color="secondary"
                                            sx={{ p: '10px' }} aria-label="directions"
                                        />
                                        {/* <Typography>{isOpen ? "Open" : "Close"}</Typography> */}
                                    </Stack>
                                    {result.length > 0 && (
                                        <Stack
                                            // backgroundColor={colors.primary[400]}
                                            // sx={{
                                            //     position: "absolute",
                                            //     left: 40,
                                            //     top: 140,
                                            //     zindex: 9999,
                                            // }}  
                                        >
                                            {result.map((user) => {
                                                return <UserResultElement user={user} handleClick={handleClickSource} />
                                            })}
                                        </Stack>
                                    )}
                                    
                                </Stack>
                            </Paper>

                            {/* New subscriber */}
                            {(sourceType === 'incoming_call' || sourceType === 'max' || sourceType === 'website') && isOpen &&
                                <Paper
                                    component="form"
                                    sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 320 }}
                                >
                                    <Stack>
                                        {/* <Typography variant='subtitle2' pb={1} pt={1} sx={{ color: colors.greenAccent[500] }}></Typography> */}
                                        
                                        <Stack spacing={1} width={'100%'}>
                                            <FormControlLabel 
                                                control={
                                                    <Checkbox
                                                        checked={newSubscriber}
                                                        onChange={handleChangeNewSoubscriber}
                                                        color='secondary'
                                                        icon={<AddCircleOutlineIcon />}
                                                        checkedIcon={<AddCircleOutlineIcon />}
                                                    />} 
                                                label="Новый клиент"
                                            />
                                            {newSubscriber && (
                                                <Stack spacing={1} p={'10px'} pl={'30px'}>
                                                    {/* <YaMap/> */}
                                                    <Typography variant='subtitle2' sx={{ color: colors.greenAccent[500] }}>
                                                        Внимание! Будет создана новая учетная запись в биллинговой системе!
                                                    </Typography>
                                                    {billings && (
                                                        <FormControl fullWidth error={errorBilling}>
                                                            <InputLabel id="billings-select-label">Billing</InputLabel>
                                                            <Select
                                                                labelId="billings-select-label"
                                                                value={billing}
                                                                onChange={handleChangeBilling}
                                                                color='secondary'
                                                                label="Billing"
                                                            >
                                                                {billings.map((billing) => {
                                                                    if (billing.provider_id !== provider.id) {
                                                                        return
                                                                    }
                                                                    return <MenuItem value={billing}>{billing.description}</MenuItem>
                                                                })}
                                                            </Select>
                                                        </FormControl>
                                                    )}

                                                    <TextField
                                                        value={login}
                                                        onChange={handleChangeLogin}
                                                        required
                                                        label="Login"
                                                        color='secondary'
                                                        error={errorLogin}
                                                        helperText={errorLogin}
                                                    />
                                                    <TextField
                                                        value={fullName}
                                                        onChange={handleChangeFullName}
                                                        required
                                                        label="Full name"
                                                        color='secondary'
                                                        error={errorFullName}
                                                        helperText={errorFullName}
                                                    />
                                                    <TextField
                                                        value={mobileTelephone}
                                                        onChange={handleChangeMobileTelephone}
                                                        required
                                                        label="Mobile telephone"
                                                        color='secondary'
                                                        error={errorMobileTelephone}
                                                        helperText={errorMobileTelephone}
                                                    />
                                                </Stack>
                                            )}
                                        </Stack>
                                    </Stack>
                                </Paper>
                            }
                            {/* END new subscriber */}

                            {/* Groups */}
                            <Paper
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 320 }}
                            >
                                <Stack>
                                    <Typography variant='subtitle2' pb={1} sx={{ color: colors.greenAccent[500] }}>
                                        Передать обращение другой группе.
                                    </Typography>
                                    <RadioGroup row defaultValue={groupId}>
                                        {appealGroups.map((el) => {
                                            if (el.provider_id !== appeal.provider_id) {
                                                return
                                            }
                                            return  <FormControlLabel
                                                        value={el.id}
                                                        // checked={el.id == groupId ? true : false}
                                                        control={<Radio color='secondary' onChange={handleChangeGroup}/>} 
                                                        label={el.name}
                                                    />
                                        })}
                                    </RadioGroup>
                                </Stack>
                            </Paper>
                            {/* Groups */}

                            {/* Comment */}
                            {change && (
                                <TextField
                                    error={errorMessageText && true}
                                    multiline
                                    // label="Comment"
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Введите сообщение...."
                                    value={messageText}
                                    color='secondary'
                                    onChange={handleChangeMessageText}
                                    // inputProps={{ 'aria-label': 'search google maps' }}
                                    helperText={errorMessageText && errorMessageText}
                                    variant="standard"
                                />
                            )}
                        </Stack>
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    {change && (
                        <Button onClick={handleSave} color="primary">
                            Save
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </Box>
    );
}
export default AppealEdit;